<template>
  <div class="shop-content">
    <ph-header>
      <van-icon name="arrow-left" size="20px" slot="left" @click="$router.back(-1)" />
    </ph-header>
    <div class="order-content">
      <van-pull-refresh v-model="pullLoading" @refresh="onRefresh">
        <van-tabs v-model="active" @change="tabChange"  animated color='#FFD133'
        sticky>
          <van-tab v-for="item in tabs" :title="item.title" :name="item.name" :key="item.id">
            <!-- 订单列表 -->
            <section class="comunity-list-box" v-if="!isEmpty">
              <van-list v-model="loading" :finished="finished" finished-text="没有更多了" :error.sync="errorLoad" :immediate-check="immediateCheck" error-text="请求失败，点击重新加载" @load="onReachBottom" :offset="1000">
                <order-item :list="list" @serve="kefu" @fatherMethod="onRefresh"></order-item>
              </van-list>
            </section>
          </van-tab>
        </van-tabs>
        <emptyData v-if="isEmpty" :message="noMsg"></emptyData>
      </van-pull-refresh>
    </div>

    <van-action-sheet v-model="custService">
      <service-sheet @close="custService=false"></service-sheet>
    </van-action-sheet>
  </div>
</template>

<script>
import PhHeader from '@/components/common/Header'
import OrderItem from '@/components/business/OrderItem'
import EmptyData from '@/components/business/EmptyData'
import { getOrderList } from '@/api/order'
import ServiceSheet from '@/components/business/ServiceSheet' 
import {
  Tab,
  Tabs
} from 'vant'
export default {
  name: 'shopOrderList',
  components: {
    PhHeader,
    OrderItem,
    EmptyData,
    ServiceSheet,
    [Tab.name]: Tab,
    [Tabs.name]: Tabs
  },
  data () {
    return {
      showPay: false,
      custService: false,
      active: '',
      tabs: [{ id: 0, title: '全部', name: '' }, { id: 1, title: '待付款', name: 'waitpay' }, { id: 2, title: '待鉴定', name: 'waitappraisal' }, { id: 3, title: '待发货', name: 'waitdeliver' }, { id: 4, title: '待收货', name: 'waitreceive' }],

      list: [],
      page: 0,
      total: 0,
      pageTotal: 0,

      pullLoading: false,

      loading: false,
      finished: false,
      errorLoad: false,
      immediateCheck: true,

      isEmpty: false,
      openid: '',
      noMsg: '你还没有订单',
      criteria: {
        pageIndex: 0,
        pageSize: 10
      },
    }
  },
  computed: {
    token () {
      return this.$store.getters.token
    }
  },
  created () {
    if(!this.token) {
      this.$router.push({ path: '/login?return_url=' + window.location.href })
    }
  },
  methods: {
    tabChange (name, title) {
      this.page = 1
      this.pageTotal = 0
      this.criteria.statusEn = name
      if (name === 0) {
        delete this.criteria.statusEn
      }
      this.getData(true)
    },
    // 下拉刷新
    onRefresh () {
      this.page = 1
      setTimeout(() => {
        this.getData(true)
      }, 300)
    },
    onReachBottom () {
      // 数据全部加载完成
      if (this.page > this.pageTotal) {
        this.finished = true
      }
      this.page++
      // 异步更新数据
      setTimeout(() => {
        this.getData()
      }, 300)
    },
    // 获取数据
    getData (refresh) {
      this.criteria.pageIndex = this.page
      this.criteria.userToken = this.token
      getOrderList(this.criteria).then(res => {
        if (refresh) {
          this.list = res.result || []
          this.pullLoading = false
        } else {
          this.list = [...this.list, ...res.result]
        }
        this.total = res.total
        this.pageTotal = res.pageCount
        if (this.list.length === 0) {
          this.isEmpty = true
        } else {
          this.isEmpty = false
        }
        // 加载状态结束
        this.loading = false
      }).catch(error => {
        this.errorLoad = true
      })
    },
    kefu () {
      this.custService = true
    },
  }
}
</script>

<style lang="less">
  .order-content {
    .van-tab {
      flex: 0 0 20% !important;
    }
  }
.action-btn {
  width: 100%;
  height: 100%;
  border: 0;
  background-color: transparent;
}
</style>
